(function () {
    setRem();
    const baseSize = 14; 
    
    function setRem() {
        const scale = document.documentElement.clientWidth / 1440;
        document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + "px";
    }

    // resize 监听页面变化
    window.addEventListener('resize', function () {
        setRem();
    }, false);
})();